import { createContext, useContext } from "react";

/**
 * Where the Worker lives, for the few calls that go around tRPC (file
 * uploads, attachment URLs). The same base the tRPC client uses.
 */
export const API_BASE: string =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.PROD
    ? "https://vy-australia-backend.kishek12.workers.dev"
    : "");

/**
 * How a page proves itself on a plain `fetch` to the Worker. The Clerk
 * provider supplies `getToken`; the dev bypass and tests supply
 * nothing, and the localhost-gated bypass identifies the caller.
 */
export interface ApiAccess {
  getToken: (() => Promise<string | null>) | null;
}

const ApiAccessContext = createContext<ApiAccess>({ getToken: null });
export const ApiAccessProvider = ApiAccessContext.Provider;

export function useApiAccess(): ApiAccess {
  return useContext(ApiAccessContext);
}

/** An attachment's stored url is relative to the Worker origin. */
export function apiUrl(relative: string): string {
  return `${API_BASE}${relative}`;
}

/** Authorization header for a plain fetch, matching what tRPC sends. */
export async function authHeaders(access: ApiAccess): Promise<HeadersInit> {
  if (!access.getToken) {
    return {};
  }
  const token = await access.getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
